export class TRCUSPSBusAddr {
    stdAddress=""
    city = ""
    state = ""
    streetNumber = ""
    streetPrefixDir = ""
    streetName = ""
    streetNameSuffix = ""
    streetSuffixDir = ""
    unitType = ""
    unitNumber = ""
    pOBoxNumber = ""
    zip = ""
    zip4 = ""
    ruralRoute = ""
    ruralBoxNumber = ""
    latitude = ""
    longitude = ""
    latax_dist = ""
    cd_no = ""
    taps_cd = ""
    in_city = ""
}